import './style.css';
import { renderNavbar } from '@/components/Navbar';
import { renderHero } from '@/components/Hero';
import { renderCapabilities } from '@/components/Capabilities';
import { renderFooter } from '@/components/Footer';

const app = document.querySelector<HTMLDivElement>('#app');

if (app) {
  app.innerHTML = `
    ${renderNavbar()}
    <main>
      ${renderHero()}
      ${renderCapabilities()}
    </main>
    ${renderFooter()}
  `;
}

